/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_macro_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2000 kcal balanced → 150 g protein, 200 g carbs, 67 g fat.`)
};

const es_macro_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2000 kcal equilibradas → 150 g de proteína, 200 g de carbohidratos, 67 g de grasa.`)
};

const de_macro_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2000 kcal ausgewogen → 150 g Protein, 200 g Kohlenhydrate, 67 g Fett.`)
};

const nl_macro_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2000 kcal uitgebalanceerd → 150 g eiwit, 200 g koolhydraten, 67 g vet.`)
};

const fr_macro_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2000 kcal équilibrées → 150 g de protéines, 200 g de glucides, 67 g de lipides.`)
};

const it_macro_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2000 kcal bilanciate → 150 g proteine, 200 g carboidrati, 67 g grassi.`)
};

const pt_br2_macro_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2000 kcal equilibrado → 150 g de proteína, 200 g de carboidratos, 67 g de gordura.`)
};

const pt_macro_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2000 kcal equilibrado → 150 g de proteína, 200 g de hidratos, 67 g de gordura.`)
};

const ja_macro_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2000kcalのバランス型 → タンパク質150g、炭水化物200g、脂質67g。`)
};

const zh_macro_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2000 千卡均衡配比 → 蛋白质 150 克，碳水 200 克，脂肪 67 克。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const macro_ex1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.macro_ex1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("macro_ex1", locale)
	if (locale === "en") return en_macro_ex1(inputs)
	if (locale === "es") return es_macro_ex1(inputs)
	if (locale === "de") return de_macro_ex1(inputs)
	if (locale === "nl") return nl_macro_ex1(inputs)
	if (locale === "fr") return fr_macro_ex1(inputs)
	if (locale === "it") return it_macro_ex1(inputs)
	if (locale === "pt-BR") return pt_br2_macro_ex1(inputs)
	if (locale === "pt") return pt_macro_ex1(inputs)
	if (locale === "ja") return ja_macro_ex1(inputs)
	return zh_macro_ex1(inputs)
};